import axios from "axios";

const productionURL = "https://chat-api.niuruihua.com"; //"https://lets-chat-express.niuruihua.com";
const localURL = "http://localhost:5095";

const URL = process.env.NODE_ENV === "production" ? productionURL : localURL;


export const baseURL = `${URL}/`;

const api = axios.create({
  baseURL,
});

export { api, URL };
